const SVGComponent = (props) => (
  <svg
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_17413_90610)">
      <path
        d="M5.99985 16.5C6.78778 16.5 7.568 16.3448 8.29595 16.0433C9.0239 15.7417 9.68534 15.2998 10.2425 14.7426C10.7996 14.1855 11.2416 13.5241 11.5431 12.7961C11.8447 12.0681 11.9998 11.2879 11.9998 10.5C11.9998 9.71207 11.8447 8.93185 11.5431 8.2039C11.2416 7.47595 10.7996 6.81451 10.2425 6.25736C9.68534 5.70021 9.0239 5.25825 8.29595 4.95672C7.568 4.6552 6.78778 4.5 5.99985 4.5C4.40855 4.5 2.88242 5.13214 1.75721 6.25736C0.631988 7.38258 -0.000152588 8.9087 -0.000152588 10.5C-0.000152588 12.0913 0.631988 13.6174 1.75721 14.7426C2.88242 15.8679 4.40855 16.5 5.99985 16.5Z"
        fill="#EB001B"
      />
      <path
        d="M13.9995 16.5C14.7874 16.5 15.5676 16.3448 16.2956 16.0433C17.0235 15.7417 17.685 15.2998 18.2421 14.7426C18.7993 14.1855 19.2412 13.5241 19.5428 12.7961C19.8443 12.0681 19.9995 11.2879 19.9995 10.5C19.9995 9.71207 19.8443 8.93185 19.5428 8.2039C19.2412 7.47595 18.7993 6.81451 18.2421 6.25736C17.685 5.70021 17.0235 5.25825 16.2956 4.95672C15.5676 4.6552 14.7874 4.5 13.9995 4.5C12.4082 4.5 10.8821 5.13214 9.75684 6.25736C8.63162 7.38258 7.99948 8.9087 7.99948 10.5C7.99948 12.0913 8.63162 13.6174 9.75684 14.7426C10.8821 15.8679 12.4082 16.5 13.9995 16.5Z"
        fill="#F79E1B"
      />
      <path
        d="M9.99949 14.9728C10.6297 14.4107 11.1337 13.7215 11.4784 12.9506C11.8231 12.1797 12.0007 11.3445 11.9995 10.5001C12.0007 9.65561 11.8231 8.82045 11.4784 8.04955C11.1337 7.27864 10.6297 6.58946 9.99949 6.02734C9.36957 6.58968 8.86572 7.27891 8.52103 8.04976C8.17634 8.82062 7.9986 9.65566 7.99949 10.5001C7.99826 11.3445 8.17584 12.1797 8.52055 12.9506C8.86526 13.7215 9.3693 14.4107 9.99949 14.9728Z"
        fill="#FF5F00"
      />
    </g>
    <defs>
      <clipPath id="clip0_17413_90610">
        <path
          d="M0 4.5C0 2.29086 1.79086 0.5 4 0.5H16C18.2091 0.5 20 2.29086 20 4.5V16.5C20 18.7091 18.2091 20.5 16 20.5H4C1.79086 20.5 0 18.7091 0 16.5V4.5Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
)
export default SVGComponent
